import { useEffect, useState } from "react";
import { Bookmark, BookmarkPlus, X } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { matchesQuery } from "@/lib/categories";

const matches = (listings, q) => listings.filter((l) => matchesQuery(l, q)).length;

export function SavedSearches({ city, listings, textQ, onRun }) {
  const [saved, setSaved] = useState([]);
  useEffect(() => { api.get("/saved-searches").then((r) => setSaved(r.data)).catch(() => {}); }, []);

  const q = textQ.trim();
  const canSave = q.length >= 2 && !saved.some((s) => s.q.toLowerCase() === q.toLowerCase());

  const save = async () => {
    try { const { data } = await api.post("/saved-searches", { q }); setSaved([data, ...saved]); toast.success(`Saved “${q}” — we'll check it in every city you visit`); }
    catch (e) { toast.error(errorMessage(e)); }
  };
  const remove = async (s) => {
    try { await api.delete(`/saved-searches/${s.id}`); setSaved(saved.filter((x) => x.id !== s.id)); } catch (e) { toast.error(errorMessage(e)); }
  };

  if (!saved.length && !canSave) return null;
  return (
    <div data-testid="saved-searches" className="mt-3 flex flex-wrap items-center gap-2">
      {saved.length > 0 && <span className="text-xs text-slate-500 flex items-center gap-1"><Bookmark className="h-3.5 w-3.5" /> Your searches in {city}:</span>}
      {saved.map((s) => {
        const n = matches(listings, s.q);
        return (
          <span key={s.id} data-testid={`saved-search-${s.id}`} className="flex items-center rounded-full border border-[#00E5A3]/40 bg-[#00E5A3]/5 text-sm">
            <button data-testid={`saved-search-run-${s.id}`} onClick={() => onRun(s.q)} className="pl-3 pr-2 py-1 hover:text-[#00E5A3]">
              {s.q} <span className="text-xs text-[#00E5A3] font-mono-vv">{n ? `${n} here` : "search"}</span>
            </button>
            <button data-testid={`saved-search-delete-${s.id}`} onClick={() => remove(s)} aria-label="Remove" className="pr-2 text-slate-500 hover:text-white"><X className="h-3.5 w-3.5" /></button>
          </span>
        );
      })}
      {canSave && (
        <button data-testid="save-search-button" onClick={save} className="flex items-center gap-1 text-sm text-[#FFB800] hover:underline">
          <BookmarkPlus className="h-4 w-4" /> Save “{q}”
        </button>
      )}
    </div>
  );
}
